export default "__VITE_ASSET__BgkOcyL9__"